import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

export function useAuth() {
  const { authorization, authenticate, logout, isLoading } = useContext(AuthContext);
  const { user, authority, isActive } = authorization;
  const isSignedIn = !!user?._id;
  return { user, authority, authorization, isActive, isSignedIn, authenticate, isLoading, logout };
}
